import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "de").slice(0, 2);

  const set = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    try { localStorage.setItem("pb24_lang", lng); } catch {}
  };

  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-1 text-[0.7rem] uppercase tracking-[0.24em] ${className}`}
    >
      <button
        type="button"
        onClick={() => set("de")}
        data-testid="lang-de"
        className={`px-1.5 py-0.5 transition-colors ${
          current === "de" ? "text-gold" : "text-cream/50 hover:text-cream"
        }`}
        aria-pressed={current === "de"}
      >
        {t("lang.de")}
      </button>
      <span className="text-cream/25">|</span>
      <button
        type="button"
        onClick={() => set("en")}
        data-testid="lang-en"
        className={`px-1.5 py-0.5 transition-colors ${
          current === "en" ? "text-gold" : "text-cream/50 hover:text-cream"
        }`}
        aria-pressed={current === "en"}
      >
        {t("lang.en")}
      </button>
    </div>
  );
}
